module.exports = __webpack_public_path__ + "img/30-3d9404.png";